import { useState } from "react";
import { toast } from "sonner";
import { Download, FileText, FileType2, FileSpreadsheet, FileCode2, Loader2, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { downloadBlob, errMsg } from "@/lib/api";

const FORMATS = [
  ["docx", "Word (.docx)", FileText, "text-sky-600"],
  ["pdf", "PDF", FileType2, "text-rose-600"],
  ["xlsx", "Excel (.xlsx)", FileSpreadsheet, "text-emerald-600"],
  ["csv", "CSV", FileCode2, "text-amber-600"],
];

export const DownloadMenu = ({ label, path, params = {}, filename, disabled, testid, variant = "outline" }) => {
  const [busy, setBusy] = useState(false);
  const go = async (fmt) => {
    setBusy(true);
    const qs = new URLSearchParams({ ...params, format: fmt }).toString();
    try { await downloadBlob(`${path}?${qs}`, `${filename}.${fmt}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled || busy}>
        <Button variant={variant} data-testid={testid}>
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Download className="w-4 h-4 mr-1" />}{label}<ChevronDown className="w-3.5 h-3.5 ml-1 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[calc(100vw-2rem)] sm:w-52">
        {FORMATS.map(([fmt, text, Icon, color]) => (
          <DropdownMenuItem key={fmt} onSelect={() => go(fmt)} className="py-2.5 sm:py-1.5 cursor-pointer" data-testid={`${testid}-${fmt}`}>
            <Icon className={`w-4 h-4 mr-2 ${color}`} />{text}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
